// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"415":"642c71ad","606":"a94b8af7","968":"86fa44c2"}[chunkId] + ".js";
};